var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thelandbpureyellow"},[_c('h1',[_vm._v(_vm._s(_vm.$t('system.spec_ready')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }